<!-- 表2填写 -->

<template>
	<div class="tabCage ssTab4E">
		<div class="tabTtl">
             <span>人员基本信息</span>
         </div>
         <div class="editArea">
            <el-form ref="paramCk" :model="params" :rules="rules">
                <table>
                      <tr>
                           <td class="edName">岗位类别：</td>
                           <td class="radioText">
                                <el-form-item prop="type" :inline-message="true">
                                    <el-radio-group disabled v-model="params.type" @change="tabSeek">
                                        <el-radio :label="1">主要负责人</el-radio>
                                        <el-radio :label="2">其他负责人</el-radio>
                                        <el-radio :label="3">编辑人员</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                           </td>
                      </tr>
                      <tr>
                           <td class="edName">姓名：</td>
                           <td class="edInp">
                                <el-form-item prop="fullName" :inline-message="true">
                                    <el-input disabled v-model="params.fullName" size="small"></el-input>
                                </el-form-item>
                           </td>
                      </tr>
                      <tr>
                           <td class="edName">性别：</td>
                           <td class="radioText">
                                <el-form-item prop="gender" :inline-message="true">
                                    <el-radio-group v-model="params.gender" disabled @change="tabSeek">
                                        <el-radio v-for="item in dicDats['C017']" :label="item.code" :key="item.code">{{ item.name }}</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                           </td>
                      </tr>
                      <tr>
                           <td class="edName">身份证号（军官证号）：</td>
                           <td class="edInp">
                                <el-form-item prop="idNumber" :inline-message="true">
                                    <el-input v-model="params.idNumber" disabled size="small"></el-input>
                                </el-form-item>
                           </td>
                      </tr>
                      <tr v-if="params.type != 3">
                           <td class="edName">职务：</td>
                           <td class="edInp">
                               <el-form-item prop="job" :inline-message="true">
                                    <el-select v-model="params.job" disabled size="small" placeholder="请选择">
                                        <el-option
                                          v-for="item in dicDats['C022']"
                                          :key="item.code"
                                          :label="item.name"
                                          :value="item.code">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                           </td>
                      </tr>
                      <tr>
                           <td class="edName">政治面貌：</td>
                           <td class="edInp">
                                <el-form-item prop="politicalStatus" :inline-message="true">
                                    <el-select v-model="params.politicalStatus" disabled size="small" placeholder="请选择">
                                        <el-option
                                          v-for="item in dicDats['C006']"
                                          :key="item.code"
                                          :label="item.name"
                                          :value="item.code">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                           </td>
                      </tr>
                      <tr>
                           <td class="edName">文化程度：</td>
                           <td class="edInp">
                                <el-form-item prop="culture" :inline-message="true">
                                    <el-select v-model="params.culture" disabled size="small" placeholder="请选择">
                                        <el-option
                                          v-for="item in dicDats['C005']"
                                          :key="item.code"
                                          :label="item.name"
                                          :value="item.code">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                           </td>
                      </tr>
                      <tr>
                           <td class="edName">手机号：</td>
                           <td class="edInp">
                                <el-form-item prop="cellphone" :inline-message="true">
                                    <el-input v-model="params.cellphone" disabled size="small"></el-input>
                                </el-form-item>
                           </td>
                      </tr>
                      <tr>
                           <td class="edName">专业：</td>
                           <td class="edInp">
                                <el-form-item prop="major" :inline-message="true">
                                    <el-input v-model="params.major" disabled size="small"></el-input>
                                </el-form-item>
                           </td>
                      </tr>
                      <tr>
                           <td class="edName">职称系列：</td>
                           <td class="edInp">
                                <el-form-item prop="professionalTitleSeries" :inline-message="true">
                                    <el-select v-model="params.professionalTitleSeries" disabled size="small" placeholder="请选择">
                                        <el-option
                                          v-for="item in dicDats['C007']"
                                          :key="item.code"
                                          :label="item.name"
                                          :value="item.code">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                           </td>
                      </tr>
                      <tr>
                           <td class="edName">职称级别：</td>
                           <td class="edInp">
                                <el-form-item prop="titleLevel" :inline-message="true">
                                    <el-select v-model="params.titleLevel" disabled size="small" placeholder="请选择">
                                        <el-option
                                          v-for="item in dicDats['C008']"
                                          :key="item.code"
                                          :label="item.name"
                                          :value="item.code">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                           </td>
                      </tr>
                      <tr>
                           <td class="edName">持有出版专业职业资格证书情况：</td>
                           <td class="edInp">
                                <el-form-item prop="certificateSituation" :inline-message="true">
                                    <el-select v-model="params.certificateSituation" disabled @change="btnCtrls(1)" size="small" placeholder="请选择">
                                        <el-option
                                          v-for="item in dicDats['C009']"
                                          :key="item.code"
                                          :label="item.name"
                                          :value="item.code">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                           </td>
                      </tr>

                      <tr v-if="params.type != 3">
                           <td class="edName">是否持有岗位培训合格证书：</td>
                           <td class="edInp">
                                <el-form-item prop="isTrainCertificate" :inline-message="true">
                                    <el-select v-model="params.isTrainCertificate" disabled @change="btnCtrls(1)" size="small" placeholder="请选择">
                                        <el-option
                                          v-for="item in dicDats['C018']"
                                          :key="item.code"
                                          :label="item.name"
                                          :value="item.code">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                           </td>
                      </tr>

                </table>
            </el-form>
         </div>

         <div class="subArea">
              <el-button @click="goBack" size="small">返回</el-button>
         </div>

	</div>
</template>

<script>
	  import { bsParams,paramsRule } from '@/components/LongParams/paramsSEt4';
    import { ssSave4,ssRead4 } from '@/api/pressRole/pressSuccessive';
    export default{

    	 data(){
    	 	 return{
                  params:bsParams,
                  rules:paramsRule,
                  submiting:false,
                  dicDats:{},
    	 	 }
    	 },
       methods:{
            dictInit:function(){
                let nameArr = ['C022','C006','C005','C007','C008','C009','C018','C017'];
                let newPromise = this.$store.dispatch('dictUpdate',{codeArr:nameArr,type:'arr'});
                newPromise.then(result => {
                     this.dicDats = result;
                })

            },

            editSave:function(name){
                 this.$refs[name].validate((valid) => {
                    if(valid){

                         this.params.publishId = this.$route.query.pressId;
                         this.params.publishMaterialId = this.$route.query.mtId;
                         this.params.publishType = this.$route.query.pressType;

                         ssSave4({plxdzworker:this.params}).then(response => {
                              this.submiting = false;
                              this.$message({
                                  message: '保存成功！',
                                  type: 'success'
                              });

                              this.goBack();

                         }).catch(error => {
                              this.submiting = false;
                         })
                    }else{
                        return false;
                    }
                 })
             },

             btnCtrls:function(type,dats){
                 if(type == 1){
                     this.btnCtrls1 = false;
                 }else if(type == 2){
                     this.btnCtrls2 = false;
                 }
             },

             menReEdit:function(){
                ssRead4({id:this.$route.query.id}).then(response => {
                  console.log('menReEdit response=',JSON.stringify(response));
                   this.params = response.plxdzworker;
                })
             },


             goBack:function(){
							  this.$router.go(-1);
                //  this.$router.push({
                //     path:'ss_listtab4',
                //     query:{
                //         listId:this.$route.query.listId,
                //         pressId:this.$route.query.pressId,
                //         mtId:this.$route.query.mtId,
                //         pressType:this.$route.query.pressType,
                //     }
                // });
             }
      },
      created:function(){
          this.dictInit();
          this.params.type = 3;
          if(this.$route.query.pgress == 2){
               this.menReEdit();
          }
      }
   }

</script>

<style lang="scss">
    @import "src/styles/pressRoleE";
    .ssTab4E .radioText{
        padding-left: 15px;
        padding-bottom: 13px;
    }

    .ssTab4E .radioText .el-radio__label{
        margin-left: -5px;
    }

    .ssTab4E .edName {
        width:240px !important;
    }

</style>



// WEBPACK FOOTER //
// ssTab4.vue?9e5ee9cc